import React from 'react';
import $ from "jquery";
import Server from '../../functions/server';
import ReadCookie from '../../functions/readcookies';
import Loading from '../loading';
import { Grid, Icon, Popup, Button } from 'semantic-ui-react';
import './style.css';
import Slide from '@material-ui/core/Slide';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Addaudit from './addaudit';
import View from './view';
import getFormatedDate from '../../functions/date';

const styles = {
  appBar: { position: 'relative', }, flex: { flex: 1, },
};

function Transition(props) { return <Slide direction="up" {...props} />; }


class Viewmaster extends React.Component {

  state = {
    data: [], load: false, fullWidth: true,
    maxWidth: 'md', maxWidth1: 'xs', datas: [],
    selectall: false, items: [],
    from_date: getFormatedDate(new Date(), 'fromDate'),
    to_date: getFormatedDate(new Date(), 'toDate'),
  }

  getFormatedDate(dates, interval) {
    if (interval > 0) {
      dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
    }
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month >= 10) ? month : "0" + month;
    date = (date >= 10) ? date : "0" + date;
    let x;
    if (interval == 'fromDate') {
      x = dates.getFullYear() + "-" + month + "-01";
    }
    else {
      x = dates.getFullYear() + "-" + month + "-" + date;
    }
    return x;
  }

  componentDidMount() { this.getInfo(); }

  checkBranch() {
    let data = (ReadCookie("branch"));
    if (data == 0) {
      this.setState({ permissionError: 'You not have permission to access this menu!!!' })
    }
    else {
      let branchId;
      for (var i = 0; i < data.length; i++) { branchId = data[i].branch_id; }
      return branchId;
    }
  }

  getInfo() {
    let context = this;
    let branchId = this.checkBranch();
    context.setState({ load: true, message: 'Getting Stock Details!!!' })
    $.ajax({
      type: 'POST',
      data: { 'from_date': this.state.from_date, 'to_date': this.state.to_date, 'branchId': branchId },
      url: Server() + 'stockaudit/getmasteraudit.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ data: data, load: false });
        } catch (e) {
          alert('Error');
          context.setState({ load: false });
          console.log(e);
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!!')
      }
    });
  }

  dateFormat(value) {
    let date = value.split(' ')[0];
    date = date.split('-')[2]+'-'+date.split('-')[1]+'-'+date.split('-')[0];
    return date;
  }

  handleChange = name => event => { this.setState({ [name]: event.target.value }); };

  render() {
    let i = 1;
    let ii = 0;
    const { classes } = this.props;
    const { value } = this.state;
    return (
      <div style={{padding: '0.5%'}}>
        <Loading load={this.state.load} message={this.state.message} />

        <div style={{display: 'flex', marginBottom: '0.2%'}}>
          <div style={{marginTop: '1.3%'}}>
            <Addaudit menuPermission={this.props.menuPermission} getStock={this.getInfo.bind(this)} stockauditedit={this.props.stockauditedit} />
          </div>
          <div style={{marginLeft: 5}}>
            <b>From Date</b><br/>
            <input type="date"  id="date" value={this.state.from_date}
              style={{height: 35 }} onChange={this.handleChange('from_date')} />
          </div>
          <div style={{marginLeft: 5}}>
            <b>To Date</b><br/>
            <input type="date" id="date" value={this.state.to_date}
              style={{height: 35 }} onChange={this.handleChange('to_date')} />
          </div>
          <Button primary onClick={this.getInfo.bind(this)} style={{height: '10%', marginTop: '1.3%', marginLeft: '0.5%'}}>Submit</Button>
        </div>
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <table id='table' width='100%'>
              <tr>
                <th id='th'><center>Sino</center></th>
                <th id='th'><center>Voucher No</center></th>
                <th id='th'><center>Created By</center></th>
                <th id='th'><center>Branch</center></th>
                <th id='th'><center>Items</center></th>
                <th id='th'><center>Not Approved</center></th>
                <th id='th'><center>Date</center></th>
                <th id='th'><center>View</center></th>
              </tr>
              { this.state.data.map((c) => {
                if (c.items > 0) {
                  let balance = 0;
                  try {
                    balance = Number(c.balance);
                  } catch (e) { }
                  let color = 'white';
                   if (balance != 0 ) { color = '#F9CABB'; }
                   return (
                     <tr id='tbody' style={{backgroundColor: color}}>
                       <td><center>{i++}</center></td>
                       <td>{c.voucher_no}</td>
                       <td>{c.creator}</td>
                       <td>{c.branch}</td>
                       <td><center>{c.items}</center></td>
                       <td><center>{c.balance}</center></td>
                       <td><center>{this.dateFormat(c.timestamp)}</center></td>
                       <td><center><View id={c.id} /></center></td>
                     </tr>
                   )
                }
                })
              }
            </table>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}


Viewmaster.propTypes = { classes: PropTypes.object.isRequired, };

export default withStyles(styles)(Viewmaster);
